import { Controller } from "@hotwired/stimulus"
import { animateCollapse } from '../../helpers/animation_helpers'

export default class extends Controller {
  static targets = ['template', 'dialog']

  open({ detail: { id } }) {
    const item = document.getElementById(id)

    this.element.appendChild(this.#template)
    this.dialogTarget.innerHTML = item.querySelector('dialog').innerHTML
    this.dialogTarget.show()

    this.#animate(0, this.dialogTarget.offsetHeight)
  }

  async close({ detail: { newId } }) {
    if (!this.hasDialogTarget) return

    if (!newId) {
      await this.#animate(this.dialogTarget.offsetHeight, 0)
    }

    this.dialogTarget.close()
    this.dialogTarget.remove()
  }

  async #animate(from, to) {
    await animateCollapse(this.dialogTarget, from, to, 'fast')
  }

  get #template() {
    return this.templateTarget.content.cloneNode(true)
  }
}
